export default __webpack_public_path__ + "static/media/edit_avatar.5e33e36e.svg";